import {getCurrentYear} from '../../utils/commons'
import ComparerMieuxLogo from './logo'
import {comparerMieuxStylesFR} from './styles'

const baseConfig = {
  domainName: 'comparermieux' as const,
  domainType: 'eu' as const,
  siteName: 'Comparer Mieux',
  favicon: '/favicons/comparermieux.png',
  styles: comparerMieuxStylesFR,
}

const localeConfigs = {
  fr: {
    measurementId: 'G-HDJYG6D5W6',
    camelCaseUrl: 'ComparerMieux.fr',
    title: (category: string, count: string) =>
      `${count} Meilleur ${category} de ${getCurrentYear()} en FR | Il y a un gagnant incontestable | ComparerMieux.fr`,
    description: (_category?: string, _count?: string) =>
      `ComparerMieux.fr analyse des milliers d'articles et d'avis clients pour trouver les produits les mieux notés aux prix les plus bas du jour. Les meilleurs produits, les meilleures offres.`,
    logo: <ComparerMieuxLogo className="size-36 shrink-0 tablet:size-28" />,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
